// theme constant
// PFI Customization: Compact Grid Spacing between 'fieldset' or sub page section
export const gridSpacing = 1;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
